define('controllers/opencard/opencard.iframe.ctrl',['app'], function (app) {
    app.controller('OpenCardIframeController', ['$state', '$sce', '$scope', '$rootScope', 'serviceresource', function ($state, $sce, $scope, $rootScope, servicecard) {
        if ($state.params.dirId && $state.params.cardId) {
            servicecard.data.fetchMc().then(function (data) {
                var card;
                if (data && data.data && data.data.serviceCards && data.data.reportCards) {
                    for (var i = 0, all = data.data.serviceCards.concat(data.data.reportCards); i < all.length; i++) {
                        if ($state.params.dirId === all[i].itemCode) {
                            for (var j = 0, resourceTree = all[i].resourceTree; j < resourceTree.length; j++) {
                                for (var k = 0, cards = resourceTree[j].cards; k < cards.length; k++) {
                                    if (cards[k].cardItem === $state.params.cardId) card = cards[k];
                                }
                            }
                        }
                    }
                    if (!card) {
                        $state.go('home');
                        sessionStorage.setItem('emptyCard', true);
                    }
                }
            });
        }
        $scope.getIframeSrc = function () {
            if (!$state.params.dirId || !$state.params.cardId) return;
            var card = servicecard.cards.getCard($state.params.dirId, $state.params.cardId);
            if (card && $state.params.param) {
                return $sce.trustAsResourceUrl(card.link.url + (card.link.url.indexOf("#") == -1 ? "?" : "/") + encodeURI($state.params.param));
            }
            if (card) return $sce.trustAsResourceUrl(card.link.url);
        }
    }]);
});
